import { useState, useEffect } from "react";
import "./Verification.css";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import Spinner from "../../Images/spinner-removebg-preview.png";
import Done from "../../Images/right.png";
import axios from "../../axios.jsx";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export default function PaymentDetails(props) {
  const [details, setDetails] = useState(null);
  const [file, setFile] = useState("");
  const [approve, setApprove] = useState(false);
  const [reason, setReason] = useState("");
  const loc = useLocation();
  const scholar = loc.state.mobile;
  const [loading, setLoading] = useState(false);
  setInterval(() => {
    if (!Cookies.get("userInfo")) {
      logout();
    }
  }, 1000);
  useEffect(() => {
    if (Cookies.get("username") != "PlagiarismOfficer") {
      alert("unauthorized to this page");
      logout();
    }
    const data = {
      mobile: scholar,
    };
    axios
      .post("/api/get-education-details", data)
      .then((resData) => {
        console.log(resData.data);
        setDetails(resData.data);
      })
      .catch((e) => {
        alert("can't find scholar");
      });
  }, []);

  const handleApproveOrReject = (e) => {
    if (e.target.value === "true") {
      document.getElementById("approve").checked = true;
      document.getElementById("reject").checked = false;
      setApprove(true);
    } else {
      document.getElementById("approve").checked = false;
      document.getElementById("reject").checked = true;
      setApprove(false);
    }
  };

  function handleSubmit(e) {
    e.preventDefault();
    let resData;
    setLoading(true);
    if (approve) {
      const req = {
        mobile: scholar,
        status: "plagiarism",
        file_name: file
      };
      axios
        .put("api/update-verification-status", req)
        .then((resData) => {
          alert("Approved Successfully");
          window.location.href = "/pending-plagiarism-list";
        })
        .catch((e) => {
          alert("server error try again");
          console.log(e);
        });
    } else {
      const req = {
        mobile: scholar,
        status: "REJECTED",
        reason,
      };
      axios
        .put("api/update-verification-status", req)
        .then((resData) => {
          alert("Rejected Successfully");
          window.location.href = "/pending-plagiarism-list";
        })
        .catch((e) => {
          alert("server error try again");
          console.log(e);
        });
    }
    setLoading(false);
  }

  function handleReasonChange(e) {
    setReason(e.target.value);
  }

  function SETFile(e) {
    handleFileUpload(e, "plagiarism_certificate").then((newFileName) =>
      setFile(newFileName)
    );
  }

  const handleFileUpload = async (file, file_name) => {
    let form_data = new FormData();
    form_data.append("file", file);
    form_data.append("file_name", file_name);
    form_data.append("mobile", Cookies.get("scholar"));
    try {
      const resData = await axios.post("/api/file-upload", form_data);
      if (resData.status === 200) {
        console.log(resData.data["file-name"]);
        return resData.data["file-name"];
      } else {
        console.log(resData);
        return "";
      }
    } catch (e) {
      console.log(e);
      return "";
    }
  };

  return (
    <>
      <br />
      <br />
      <form className="Auth-form" onSubmit={handleSubmit}>
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Verify Thesis and Synopsis</h3>
          {details === null ? (
            <center>
              <RotateLeftIcon
                sx={{
                  fontSize: "3rem",
                  margin: "0 auto",
                  color: "rgba(0,0,0,0.6)",
                  animation: "spin 1s linear infinite",
                  "@keyframes spin": {
                    "0%": {
                      transform: "rotate(360deg)",
                    },
                    "100%": {
                      transform: "rotate(0deg)",
                    },
                  },
                }}
              />{" "}
              Loading Details
            </center>
          ) : (
            <div className="form-group mt-3">
              <table>
                <tr>
                  <td>
                    <label>Scholar Mobile</label>
                  </td>
                  <td>
                    <input
                      value={details.mobile}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Title</label>
                  </td>
                  <td>
                    <input
                      value={details.title_of_thesis}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Synopsis File</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + details.synopsis} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Thesis File</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + details.thesis} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
              </table>
              <div>
                <input
                  onClick={handleApproveOrReject.bind(this)}
                  type="radio"
                  id="approve"
                  defaultChecked={approve ? true : false}
                  style={{ marginRight: 10 }}
                  value="true"
                  required
                />
                <label>Approve</label>
                <input
                  onClick={handleApproveOrReject.bind(this)}
                  type="radio"
                  id="reject"
                  defaultChecked={!approve ? true : false}
                  style={{ marginLeft: 10, marginRight: 10 }}
                  value="false"
                  required
                />
                <label>Reject</label>
              </div>
              {!approve && (
                <textarea
                  value={reason}
                  onChange={(e) => handleReasonChange(e)}
                />
              )}
              {approve && (
                <>
                  <input
                    onChange={(e) => SETFile(e.target.files[0])}
                    className="form-control"
                    required={file === "" ? true : false}
                    type="file"
                  />
                  {file === "load" ? (
                    <div style={{ "padding-top": "5px" }}>
                      <img className="spinner_img" src={Spinner} alt="" />
                      &nbsp;&nbsp;Uploading
                    </div>
                  ) : (
                    file !== "" && (
                      <div style={{ "padding-top": "5px" }}>
                        <span className="file-name">
                          <img className="done_img" src={Done} alt="" />
                          &nbsp;{file}
                        </span>
                      </div>
                    )
                  )}
                </>
              )}
              <div className="d-grid gap-2 mt-3">
                <button
                  type="submit"
                  className="btn btn-secondary approve-btn"
                  disabled={loading}
                >
                  Submit
                </button>
              </div>
            </div>
          )}
        </div>
      </form>
    </>
  );
}

function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  Cookies.remove("username");
  window.location.href = "/pvtOfficer-login";
}
